var new_date = new Date(
  new Date().setDate(new Date().getDate() + 30)
).toLocaleDateString('pt');
const siteTitle = 'Conclua seu pedido';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Preencha seus dados',
    formTitle2: 'Você paga aqui',
    btnForm: 'Continuar',
    btnForm2: 'Pagar',
    priceText1: 'Pagamento',
    priceText2: 'Total',
    footerTitle: 'Pagamento online',
    footerText: 'Confirme com seu cartão de crédito',
    shippingInfoText: 'Informações de envio e faturação',
    paymentInfoText: 'INFORMAÇÕES DE PAGAMENTO',
    agreengText:
      'Ao clicar em "Continuar", confirmo que li, consenti e aceitei os Termos e Condições, a Política de Privacidade, e que tenho pelo menos 18 anos de idade.',
    checkboxText:
      'Concordo em receber notificações de newsletters, ofertas e serviços de comunicação.',
    bigFooterText: `Graças à sua adesão, você também participa de nosso concurso para ganhar o ${siteTitle}. Selecionamos um vencedor entre cada 600 participantes. O próximo vencedor será selecionado em ${new_date} e será notificado diretamente por e-mail. Se a recompensa estiver esgotada, o vencedor receberá um produto semelhante de valor igual ou superior.`,
    bigFooterText1: `Garantimos que nossos membros recebam um histórico detalhado de transações e, por isso, saibam o que estão pagando. As informações do cartão de crédito são necessárias apenas para facilitar compras futuras. Não haverá cobrança na fatura do seu cartão de crédito se você não atualizar para a assinatura PREMIUM e não fizer uma compra.`,
    bigFooterText2: `Ao aderir a este serviço, você receberá uma avaliação de 5 dias do programa de nosso parceiro. Se continuar com uma assinatura além do período experimental de 5 dias, será cobrado um valor no seu cartão de crédito que varia dependendo da escolha da tarifa. Quando a sua contribuição for deduzida do seu cartão de crédito ou outro meio de pagamento, você terá acesso a esses serviços que são reservados exclusivamente aos membros do site do nosso parceiro.`,
    subtotalText: 'Subtotal',
    amountText: 'Valor a ser pago',
    shippingText: 'Envio',
    totalText: 'Total',
    freeText: 'Grátis',
    countryLabel: 'País',
    country: 'Portugal',
  },
  home: {
    placeholder: {
      firstName: 'Primeiro nome',
      lastName: 'Último nome',
      email: 'O email',
      phone: 'Telefone',
      city: 'Cidade',
      address: 'Endereço',
      zip: 'Fecho eclair',
      continue: 'Continuar',
      name: 'Nome',
      confirmPayment: 'Confirme o pagamento',
    },
    cardNumber: 'Número do cartão',
    expirationDate: 'Data de validade',
    name: 'Nome',
    month: 'Mês',
    year: 'Ano',
    cvv: 'CVV',
    confirmPayment: 'Confirme o pagamento',
    timer: 'Tempo restante até o pagamento do pedido',
  },
  validation: {
    requireEmail: 'O seu email está vazio.',
    validEmail: 'Email inválido.',
    requirePhone: 'O seu telefone está vazio.',
    minPhone: 'O campo do telefone deve ter pelo menos 10 caracteres.',
    requireFirstName: 'O primeiro nome é obrigatório.',
    validFirstName: 'O primeiro nome é inválido',
    requireLastName: 'O campo sobrenome é obrigatório.',
    validLastName: 'O campo sobrenome é inválido',
    requireCity: 'O campo da cidade é obrigatório.',
    validCity: 'O campo da cidade é inválido',
    requireAddress: 'O campo de endereço é obrigatório.',
    validAddress: 'O campo de endereço é inválido',
    requireZip: 'O campo zip é obrigatório.',
    validZip: 'O campo zip é inválido.',
    requireCard: 'O campo do número do cartão é obrigatório.',
    minCard: 'Símbolos insuficientes.',
    validCard: 'O campo do número do cartão é inválido.',
    requireMonth: 'O campo do mês de vencimento é obrigatório.',
    requireYear: 'O campo do ano de vencimento é obrigatório.',
    requireName: 'O campo nome é obrigatório.',
    validName: 'O campo do nome é inválido.',
    requireCvv: 'O campo cvv é obrigatório.',
    validCvv: 'O campo cvv é inválido.',
    minFirstName: 'O campo do primeiro nome deve ter pelo menos 3 caracteres.',
    minLastName: 'O campo sobrenome deve ter pelo menos três caracteres.',
    minCity: 'O campo da cidade deve ter pelo menos três caracteres.',
    minAddress: 'O campo de endereço deve ter pelo menos três caracteres.',
    minZip: 'O campo do código postal deve ter pelo menos três caracteres.',
    minName: 'O campo do nome deve ter pelo menos três caracteres.',
    minCvv: 'O campo cvv deve ter pelo menos 3 caracteres.',
    specialFirstName: 'O nome do campo não deve conter caracteres especiais',
    specialLastName:
      'O sobrenome do campo não deve conter caracteres especiais',
    specialName: 'O nome do campo não deve conter caracteres especiais',
    specialCity: 'A cidade do campo não deve conter caracteres especiais',
  },
  mask: {
    phone: '+351 999 999 999',
    zip: 'XXXXXX XX9',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'ENTRAR EM CONTATO',
    firstName: 'Primeiro nome',
    lastName: 'Último nome',
    email: 'O email',
    msg: 'Mensagem',
    send: 'Mandar',
    alreadyRegistered: 'Você já se registrou',
    unsubscribeLink: 'Cancelar inscrição no link',
    worktime: 'O call center funciona das 10h às 17h',
    phone: 'Telefone: Sofia +359 2 437 4207',
  },
};
